module.exports = __webpack_public_path__ + "img/partone_pic3.51f34576.png";